// extracted by mini-css-extract-plugin
export var arrow = "_2w-6";
export var changeItem = "_2w-3";
export var changesHeader = "_2w-1";
export var changesList = "_2w-2";
export var container = "_2w-0";
export var pathLabel = "_2w-4";
export var value = "_2w-7";
export var valuesContainer = "_2w-5";